module.exports = __webpack_public_path__ + "static/contenu-82d6ec6a5a2a4ef4ec98c0ecfe812f58.jpg";